<template>
  <div>
  <div class="slds-page-header slds-page-header_record-home">
    <div class="slds-page-header__row">
      <div class="slds-page-header__col-title">
        <div class="slds-media">
          <div class="slds-media__figure">
            <span class="slds-icon_container slds-icon-standard-opportunity">
              <svg class="slds-icon slds-page-header__icon" aria-hidden="true">
                <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#opportunity"></use>
              </svg>
            </span>
          </div>
          <div class="slds-media__body">
            <div class="slds-page-header__name">
              <div class="slds-page-header__name-title">
                <h1>
                  <span>Dashboard</span>
                  <span class="slds-page-header__title slds-truncate" :title="`${dashboardName}`">{{dashboardName}}</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="slds-page-header__col-actions">
        <div class="slds-page-header__controls">
          
          <div class="slds-page-header__control">
            <ul class="slds-button-group-list">
              <li>
                <button class="slds-button slds-button_neutral" v-on:click="showListElementPopup();">Add Segment</button>
              </li>
              <li>
                <router-link :to="{ name: 'Dashboard'}">
                  <button class="slds-button slds-button_neutral">Back</button>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="slds-page-header__row slds-page-header__row_gutters">
      <div class="slds-page-header__col-details">
        <ul class="slds-page-header__detail-row">
          <li class="slds-page-header__detail-block">
            <div class="slds-text-title slds-truncate" title="Title">Title</div>
            <div class="slds-truncate">{{dashboardTitle}}</div>
          </li>
          <li class="slds-page-header__detail-block">
            <div class="slds-text-title slds-truncate" title="Description">Description</div>
            <div class="slds-truncate">{{dashboardDescription}}</div>
          </li>
          <li class="slds-page-header__detail-block">
            <div class="slds-text-title slds-truncate" title="Segments">Segments</div>
            <div class="slds-truncate">{{dashboardSegments}}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <notifications group="success" />

  <table class="slds-table slds-table_cell-buffer slds-no-row-hover slds-table_bordered slds-table_fixed-layout slds-m-top_large slds-table_striped slds-table_col-bordered" role="grid">
        <thead>
          <tr>
              <th class="nameColumn"><div class="">Segment Name</div></th>
              <th class="numberCol"><div class=""># Solicited</div></th>
              <th class="numberCol"><div class=""># Gifts</div></th>
              <th class="numberCol"><div class="">$ Gifts</div></th>
              <th class="numberCol"><div class="">Response Rate</div></th>
              <th class="numberCol"><div class="">Avg. Gift</div></th>
              <th class="numberCol"><div class="">In / Out</div></th>
              <th class="numberCol"><div class="">$ Cost</div></th>
              <th class="numberCol"><div class="">Cost / Piece</div></th>
              <th class="numberCol"><div class="">Net Cost / Donor</div></th>
              <th class="shortNumCol"><div class="">$1,000+</div></th>
              <th class="shortNumCol"><div class="">$500-$999</div></th>
              <th class="shortNumCol"><div class="">$250-$499</div></th>
              <th class="shortNumCol"><div class="">$100-$249</div></th>
              <th class="shortNumCol"><div class="">$59-$99</div></th>
              <th class="shortNumCol"><div class="">$25-$49</div></th>
              <th class="shortNumCol"><div class="">$1-$24</div></th>
              <th class="numberCol"><div class="">Actions</div></th>
          </tr>
        </thead>
        <tbody>
          <tr class="slds-hint-parent" v-for="data in segmentList" :key="data.id">
              <td>{{data.segmentName}}</td>
              <td>{{data.solicitedNumber | dataFormatter('number')}}</td>
              <td>{{data.numberOfGifts | dataFormatter('number')}}</td>
              <td>{{data.amountOfGifts | dataFormatter('currency-no-decimals')}}</td>
              <td>{{data.responseRate | dataFormatter('percent-2-decimals')}}</td>
              <td>{{data.avgGift | dataFormatter('currency-no-decimals')}}</td>
              <td>{{data.inOutCost | dataFormatter('decimal')}}</td>
              <td>{{data.totalCost | dataFormatter('currency-no-decimals')}}</td>
              <td>{{data.costPrice | dataFormatter('currency')}}</td>
              <td>{{data.netCost | dataFormatter('currency')}}</td>
              <td>{{data.thousandPlusDonor | dataFormatter('number')}}</td>
              <td>{{data.fiveHundredPlusDonor | dataFormatter('number')}}</td>
              <td>{{data.twoFiftyPlusDonor | dataFormatter('number')}}</td>
              <td>{{data.hundredPlusDonor | dataFormatter('number')}}</td>
              <td>{{data.fiftyPlusDonor | dataFormatter('number')}}</td>
              <td>{{data.twentyFivePlusDonor | dataFormatter('number')}}</td>
              <td>{{data.onePlusDonor | dataFormatter('number')}}</td>
              <td>
                <ul class="slds-button-group-row">
                  <li class="slds-button-group-item">
                    <router-link :to="{ name: 'CampaignReport', params: { dashboardData:data, dashboardInfo:dashboardDataFromSegment, IsFromSegments:true}}">
                      <button class="slds-button slds-button_icon slds-button_icon-border-filled">
                        <svg class="slds-button__icon" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#chart"></use>
                        </svg>
                        <span class="slds-assistive-text">Report</span>
                      </button>
                    </router-link>
                  </li>
                  <li class="slds-button-group-item">
                    <button @click="showEditSegments(data)" class="slds-button slds-button_icon slds-button_icon-border-filled">
                      <svg class="slds-button__icon" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#edit"></use>
                      </svg>
                      <span class="slds-assistive-text">Edit</span>
                    </button>
                  </li>
                  <li class="slds-button-group-item">
                    <button @click="editDeletepopup(data.segmentId)" class="slds-button slds-button_icon slds-button_icon-border-filled slds-button_icon-error" 
                    v-bind:name="data.id">
                      <svg class="slds-button__icon" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
                      </svg>
                      <span class="slds-assistive-text">Delete</span>
                    </button>
                  </li>
                </ul>
              </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
              <th class="nameColumn"><div class="">Segment Name</div></th>
              <th class="numberCol"><div class=""># Solicited</div></th>
              <th class="numberCol"><div class=""># Gifts</div></th>
              <th class="numberCol"><div class="">$ Gifts</div></th>
              <th class="numberCol"><div class="">Response Rate</div></th>
              <th class="numberCol"><div class="">Avg. Gift</div></th>
              <th class="numberCol"><div class="">In / Out</div></th>
              <th class="numberCol"><div class="">$ Cost</div></th>
              <th class="numberCol"><div class="">Cost / Piece</div></th>
              <th class="numberCol"><div class="">Net Cost / Donor</div></th>
              <th class="shortNumCol"><div class="">$1,000+</div></th>
              <th class="shortNumCol"><div class="">$500-$999</div></th>
              <th class="shortNumCol"><div class="">$250-$499</div></th>
              <th class="shortNumCol"><div class="">$100-$249</div></th>
              <th class="shortNumCol"><div class="">$59-$99</div></th>
              <th class="shortNumCol"><div class="">$25-$49</div></th>
              <th class="shortNumCol"><div class="">$1-$24</div></th>
              <th class="numberCol"><div class="">Actions</div></th>
          </tr>
        </tfoot>
    </table>

   <!--Element popup-->
   <div v-show="showElementPopup">
      <section role="dialog" tabindex="-1" class="slds-modal slds-fade-in-open slds-modal_small" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1">
          <div class="slds-modal__container">
            <header class="slds-modal__header">
              <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close"  v-on:click="closeListElementPopup()">
                <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                </svg>
                <span class="slds-assistive-text">Close</span>
              </button>
              <h2 id="modal-heading-01" class="slds-modal__title slds-hyphenate">{{segmentHeader}}</h2>
            </header>
            <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
              <notifications group="popup" />
              <div class="slds-col slds-size_4-of-6">
                <div class="vld-parent">
                  <loading :active.sync="isLoading" 
                  :can-cancel="true" 
                  :on-cancel="onCancel"
                  :is-full-page="fullPage"></loading>
                </div>
              </div>
              <p v-if="errorsForSegment.length">
                  <b>Please correct the following error(s):</b>
                <ul>
                  <li v-for="error in errorsForSegment" v-bind:key="error">{{ error }}</li>
                </ul>
              </p>
              <div class="slds-form--stacked">
                <div class="slds-form-element">
                    <label class="slds-form-element__label" for="segmentName">Segment Name</label>
                    <div class="slds-form-element__control">
                      <input id="segmentName" class="slds-input" type="text" v-model="segmentName" placeholder="Segment Name" />
                    </div>
                  </div>
                  <div class="slds-form-element">
                    <label class="slds-form-element__label" for="segmentCampaignId">Campaigns</label>
                    <div class="slds-form-element__control">
                      <textarea id="segmentCampaignId" class="slds-textarea" rows="6" cols="50" 
                      placeholder="Campaign Names" v-model="segmentCampaignIds"/>
                    </div>
                  </div>
                </div>
                
              </div>
              <footer class="slds-modal__footer">
                  <button class="slds-button slds-button_neutral"  v-on:click="closeListElementPopup()">Cancel</button>
                  <button class="slds-button slds-button_brand" v-on:click="addSegmentElement()">Save</button>
                </footer>
          </div>
          
        </section>

      <div class="slds-backdrop slds-backdrop_open"></div>
    </div>

    <!--Delete prompt-->
    <div v-show="showConfirmDeletePopup">
      <div class="demo-only" style="height:24rem">
        <section role="alertdialog" tabindex="0" aria-labelledby="prompt-heading-id" aria-describedby="prompt-message-wrapper" class="slds-modal slds-fade-in-open slds-modal_prompt" aria-modal="true">
          <div class="slds-modal__container">
            <header class="slds-modal__header slds-theme_error slds-theme_alert-texture">
              <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse" title="Close">
                <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                </svg>
                <span class="slds-assistive-text">Close</span>
              </button>
              <h2 class="slds-text-heading_medium" id="prompt-heading-id">Delete Segment</h2>
            </header>
            <div class="slds-modal__content slds-p-around_medium" id="prompt-message-wrapper">
              <notifications group="delete" />
              <p><center>Are you sure you want to delete this Segment?</center></p>
            </div>
            <footer class="slds-modal__footer slds-theme_default">
              <button class="slds-button slds-button_brand" @click="deleteSegments()">Okay</button>
              <button class="slds-button slds-button_neutral" @click="closeDeletePopup()">Cancel</button>
            </footer>
          </div>
        </section>
        <div class="slds-backdrop slds-backdrop_open"></div>
      </div>
    </div>
    <!--delete popup end--> 

  </div>
</template>

<script>
import {saveSegmentUrl, deleteSegmentUrl, getSegmentDataUrl } from '../config';

import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import dataFormatter from '../filters/dataFormatter.js'
export default {
    name: "segmentScreen",
    data() {
      return {
        id: '',
        segmentData: [],
        errorsForSegment:[],
        showElementPopup:false,
        segmentList:[],
        newSegment:{},
        segmentCampaignIds:'',
        segmentName:'',
        segmentTitle:'',
        segmentDesc:'',
        isLoading: false,
        fullPage: true,
        dashboardId:'',
        dashboardName:'',
        dashboardTitle:'',
        dashboardDescription:'',
        dashboardSegments:'',
        segmentHeader:'Add Segment',
        showConfirmDeletePopup:false,
        segmentIdtoDelete:'',
        dashboardDataFromSegment:{}
      }
    },
    components: {
      Loading
    },
		filters: {
			dataFormatter,

		},
    created: function() {
      this.dashboardDataFromSegment={};
      if(this.$route.params.dashboardData!=undefined){
        this.dashboardDataFromSegment = this.$route.params.dashboardData;
        this.dashboardId = this.$route.params.dashboardData.id;
        this.dashboardName= this.$route.params.dashboardData.name;
        this.dashboardTitle= this.$route.params.dashboardData.title;
        this.dashboardSegments = this.$route.params.dashboardData.segments;
        this.dashboardDescription = this.$route.params.dashboardData.description;
      }
     
      this.getSegmentData();
    },
    methods: {
      getSegmentData: function () {
        console.log('this.dashboardId'+this.dashboardId);
        
        this.axios.get(getSegmentDataUrl + this.dashboardId)
        .then((response) => {
          this.segmentList = JSON.parse(JSON.stringify(response.data));
          this.isLoading = false; 
        }).catch((error => {
          console.log(error);
          this.isLoading = false;             
        }))
      },
      addSegmentElement : function () {
        this.errorsForSegment  = [];
        
        if (this.segmentName=='') {
          this.errorsForSegment.push("Name is required.");
        }
        if (this.segmentCampaignIds=='') {
          this.errorsForSegment.push("Campaigns are required.");
        }

        if (!this.errorsForSegment.length) {
          this.isLoading = true;
          this.newSegment = {};
          this.newSegment.dashboardId = this.$route.params.dashboardData.id;
          this.newSegment.name=this.segmentName;
          this.newSegment.title=this.segmentTitle;
          this.newSegment.description=this.segmentDesc;
          this.newSegment.id = this.id;
          
          if(this.segmentCampaignIds!=null&&this.segmentCampaignIds!=''&&this.segmentCampaignIds!=undefined){
            this.newSegment.filterIds=this.segmentCampaignIds.replace(new RegExp('\\n', 'g'), ',');
          }
          
          this.axios.post(saveSegmentUrl,this.newSegment)
          .then((response) => {
              if(this.id > 0){
                this.$notify({
                  group: 'success', type: 'success', duration: 2000,
                  title: 'Details udpated!',
                  text: 'Segment ' + this.segmentName + ' updated successfully.'
                });      
              }else{
                this.$notify({
                  group: 'success', type: 'success', duration: 2000,
                  title: 'Details udpated!',
                  text: 'Segment ' + this.segmentName + ' added successfully.'
                });      
              }
            
              this.getSegmentData();
              console.log('segments111'+JSON.stringify(response));
              //this.createDashboardSegments(response.data.id);
              this.showElementPopup=false;
          }).catch((error => {
            console.log(error);
             this.$notify({
                group: 'popup', type: 'warning', duration: 1000,
                title: 'Warning!',
                text: error
              });
          })) 
        }
    },
    deleteSegments: function (){
      this.axios.post(deleteSegmentUrl + this.segmentIdtoDelete)
          .then((response) => {
            console.log(response);
            this.$notify({
              group: 'success', type: 'success', duration: 1000,
              title: 'Segment data deleted!',
              text: 'Segment data deleted successfully.'
            });
            this.showConfirmDeletePopup = false;
            this.getSegmentData();
          }).catch((error => {
            this.showConfirmDeletePopup = false;
            console.log(error);
            this.$notify({
                group: 'success', type: 'warning', duration: 1000,
                title: 'Warning!',
                text: error
              });
          }))
    },
    showEditSegments: function (data){
      this.resteSegmentData();
      this.segmentHeader = 'Edit Segment';
      this.showElementPopup =  true;
      this.id = data.segmentId;
      this.segmentName  = data.segmentName;
      this.segmentTitle = data.segmentTitle;
      this.segmentDesc  = data.segmentDescription;
      if(data.filterIds!=null&&data.filterIds!=''){
        this.segmentCampaignIds = data.filterIds.replace(new RegExp(',', 'g'), '\r\n');
      }
      //this.dashboardId = data.dashboardId;
      
      this.errorsForSegment = [];
    },
    resteSegmentData: function (){
      
      this.newSegment = {};
      this.segmentName='';
      this.segmentTitle='';
      this.segmentDesc='';
      this.segmentCampaignIds = '';
      this.segmentIdToEdit = '';
      this.errorsForSegment=[];
    },
    showListElementPopup : function () {
      this.resteSegmentData();
      this.segmentHeader = 'Add Segment';
      this.showElementPopup=true;
      this.errorsForSegment = [];
    },
    closeListElementPopup: function () {
      this.segmentHeader = 'Add Segment';
      this.showElementPopup=false;
      this.resteSegmentData();
      this.errorsForSegment = [];
      this.id = '';
    },
    onCancel() {
      
    },
    editDeletepopup: function (segmentId){
      this.segmentIdtoDelete = segmentId;
      this.showConfirmDeletePopup = true;
    },
    closeDeletePopup : function (){
      this.segmentIdtoDelete = '';
      this.showConfirmDeletePopup = false;
    },
  }
}
</script>
<style scoped>
  .nameColumn {
    width: 45ch;
    white-space: pre-line;
  }
  .numberCol {
		width: 125px;
	}
	.shortNumCol {
		width: 85px;
	}
</style>